import { DOCUMENT } from '@angular/common';
import { Inject, OnDestroy } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ShopAndShipService,
  ShopAndShipCountryContent,
  ShopAndShipCountry,
} from '../../services/shop-and-ship.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { TitleAndDescriptionsService } from 'src/app/services/titles-and-descriptions.service';

@Component({
  selector: 'shop-and-ship-page',
  templateUrl: './shop-and-ship-page.component.html',
  styleUrls: ['./shop-and-ship-page.component.css'],
})
export class ShopAndShipPageComponent implements OnInit, OnDestroy {
  lpCountriesContents: ShopAndShipCountryContent[] | null | undefined;
  fromCountryName!: string;
  toCountryName!: string;
  toCountryDetail!: ShopAndShipCountry;
  fromCountryDetail!: ShopAndShipCountry;
  countryName!: string;
  countryCode!: string;
  accordionSet: any;
  slideSet: any;
  commentsSectionTitle!: string;
  brandsGridTitle!: string;
  brandsContent: any;
  lang!: string;
  mainSchema: any;
  articleSchema: any;
  breadCrumbSchema: any;
  faqSchema: any;
  reviewsSchema: any;
  servicesSchema: any;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _ShopAndShipService: ShopAndShipService,
    @Inject(DOCUMENT) private document: any,
    private watcherService: WatcherService,
    private metaTitleService: TitleAndDescriptionsService
  ) { }

  ngOnInit() {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    this._route.params.subscribe((params) => {
      this.fromCountryName = params['fromCountryName'].split('from-').join('');
      this.toCountryName = params['toCountryName'].split('to-').join('');
      this.toCountryDetail = this._ShopAndShipService.getCountries().find((country) => country.country_route === this.toCountryName);
      this.fromCountryDetail = this._ShopAndShipService.getCountries().find((country) => country.country_route === this.fromCountryName);
      if(this.toCountryDetail === undefined || this.fromCountryDetail === undefined || this.toCountryDetail === null || this.fromCountryDetail === null
        || this.toCountryDetail.country_name === this.fromCountryDetail.country_name
      ) {
        return this._router.navigate(['/404']);
      }
      this.removeSchemas();
      this.loadCountryData(this.fromCountryName, this.toCountryDetail.country_name);
      this.updateMetas();
    });
  }
  loadCountryData(route: string, toCountryName: string) {
    this.lpCountriesContents = this._ShopAndShipService.getContentCombined(route, toCountryName);
    if(this.lpCountriesContents === undefined || this.lpCountriesContents === null) {
      return this._router.navigate(['/404']);
    }
    const dataSet = this.lpCountriesContents.find((countryContent) => {
      return countryContent.countryRoute === route;
    });
    
    this.countryCode = dataSet?.countryCode;
    this.countryName = dataSet?.countryName;
    this.accordionSet = dataSet?.accordionSet;
    this.slideSet = dataSet?.slideSet;
    this.commentsSectionTitle = dataSet?.commentsSectionTitle;
    this.brandsGridTitle = dataSet?.brandsGridTitle;
    this.brandsContent = dataSet?.brandsContent;
    this.mainSchema = dataSet?.mainSchema;
    this.breadCrumbSchema = dataSet?.breadcrumbSchema;
    this.faqSchema = dataSet?.faqSchema;
    this.articleSchema = dataSet?.articleSchema;
    this.servicesSchema = dataSet?.servicesSchema;
    this.createSchemas(); 
  }
  createSchemas() {
    const mainSchema = this.mainSchema;
    const scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.innerHTML = JSON.stringify(mainSchema);
    scriptEl.id = 'mainSchema';
    this.document.head.appendChild(scriptEl);

    // Article Schema
    const articleSchema = this.articleSchema;
    const articleScriptEl = document.createElement('script');
    articleScriptEl.type = 'application/ld+json';
    articleScriptEl.innerHTML = JSON.stringify(articleSchema);
    articleScriptEl.id = 'articleSchema';
    this.document.head.appendChild(articleScriptEl);

    // Breadcrumb Schema
    const breadCrumbSchema = this.breadCrumbSchema;
    const breadCrumbScriptElement = document.createElement('script');
    breadCrumbScriptElement.type = 'application/ld+json';
    breadCrumbScriptElement.textContent = JSON.stringify(breadCrumbSchema);
    breadCrumbScriptElement.id = 'breadcrumbScript';
    this.document.head.appendChild(breadCrumbScriptElement);

    // FAQ Schema
    const faqSchema = this.faqSchema;
    
    const faqSchemaScriptElement = document.createElement('script');
    faqSchemaScriptElement.type = 'application/ld+json';
    faqSchemaScriptElement.textContent = JSON.stringify(faqSchema);
    faqSchemaScriptElement.id = 'faqSchema'; 
    this.document.head.appendChild(faqSchemaScriptElement);
    // Reviwes Schema
    const reviwesSchema = this.reviewsSchema;
    const reviwesSchemaScriptElement = document.createElement('script');
    reviwesSchemaScriptElement.type = 'application/ld+json';
    reviwesSchemaScriptElement.textContent = JSON.stringify(reviwesSchema);
    reviwesSchemaScriptElement.id = 'reviewsSchema';
    this.document.head.appendChild(reviwesSchemaScriptElement);

    // Services Schema
    const servicesSchema = this.servicesSchema;
    const servicesSchemaScriptElement = document.createElement('script');
    servicesSchemaScriptElement.type = 'application/ld+json';
    servicesSchemaScriptElement.textContent = JSON.stringify(servicesSchema);
    servicesSchemaScriptElement.id = 'servicesSchema';
    this.document.head.appendChild(servicesSchemaScriptElement);
  }
  removeSchemas() {
    const schemas = [
      'mainSchema',
      'articleSchema',
      'breadcrumbScript',
      'faqSchema',
      'reviewsSchema',
      'servicesSchema'
    ];

    schemas.forEach((schemaId) => {
      const schemaElement = document.getElementById(schemaId);
      if (schemaElement) {
        document.head.removeChild(schemaElement);
      }
    });
  }
  updateMetas(){
    this.metaTitleService.updateWebPageTitle(
      `Shop from ${this.fromCountryDetail.country_name} & Ship to ${this.toCountryDetail.country_name} | Fast ${this.fromCountryDetail.country_name}-${this.toCountryDetail.country_name} Delivery Service | Shippn`
    )
    this.metaTitleService.updateWebsiteDescription(
      `Shop from top ${this.fromCountryDetail.country_code} brands like ASOS and John Lewis with fast delivery to ${this.toCountryDetail.country_name}! Get your free ${this.fromCountryDetail.country_code} address, enjoy seamless shopping from ${this.fromCountryDetail.country_nat} retailers, and experience reliable shipping to ${this.toCountryDetail.country_name} with full tracking. Start shopping ${this.fromCountryDetail.country_code} brands today!`
    )
  }
  ngOnDestroy(): void {
    this.removeSchemas();
  }
}